
  import { defineComponent } from "@vue/runtime-core"
  import { useRouter } from "vue-router"

  export default defineComponent({
    name: "UserCard",
    components: {},
    inject: ["Ti18N"],
    props: {
      userData: Object
    },
    setup(props: any) {
      const router = useRouter()
      const redirect = () => router.push("/account/" + props.userData.id)

      return { redirect }
    },
  })
